import React from 'react';
import reviewers from './reviewer_list.pdf'
import { Link } from 'react-router-dom';

const Committee = () => {
  const cardStyle = {
    width: '20rem',
    display: 'inline-block',
    marginRight: '1rem',
    color:"white",
    whiteSpace: 'nowrap',
  };

  const marqueeContainerStyle = {
    overflow: 'hidden',
    whiteSpace: 'nowrap',
  };

  const marqueeScrollStyle = {
    display: 'inline-block',
    animation: 'scroll-left 20s linear infinite',
  };

const Chief_Patron = [
  {
    Name: "PROF. SANTISHREE DHULIPUDI PANDIT",
    Organization: "Hon. Vice Chancellor, Jawaharlal Nehru University, New Delhi",
    Country: "India"
  }
];

const Patrons = [
  {
    Name: "SATISH CHAND",
    Organization: "School of Computer & Systems Sciences, JNU, New Delhi",
    Country: "India"
  },
  {
    Name: "MANJU KHARI",
    Organization: "School of Computer & Systems Sciences, JNU, New Delhi",
    Country: "India"
  },
  {
    Name: "ZAHID RAZA",
    Position:"",
    Organization: "Jawaharlal Nehru University, New Delhi",
    Country: "India"
  },
  // {
  //   Name: "PROF. BRAJESH KUMAR PANDEY",
  //   Organization: "Rector-I, Jawaharlal Nehru University, New Delhi",
  //   Country: "India"
  // }
];


const CoPatrons = [
  // {
  //   Name: "MANJU KHARI",
  //   Organization: "School of Computer & Systems Sciences, JNU, New Delhi",
  //   Country: "India"
  // },
  // {
  //   Name: "ZAHID RAZA",
  //   Position:"",
  //   Organization: "Jawaharlal Nehru University, New Delhi",
  //   Country: "India"
  // },
  
  // {
  //   Name: "ABDUL QUAIYUM ANSARI",
  //   Position:"Vice Chair,  IEEE India Council",
  //   Organization: "Jamia Millia Islamia, New Delhi",
  //   Country: "India"
  // },
  // {
  //   Name: "M N HODA",
  //   Position:"Chairperson, IEEE Delhi Section, India",
  //   Organization: "Bharati Vidyapith Institute of Computer Application and Management, New Delhi",
  //   Country: "India"
  // }
];

const Ieee_streeing = [
   {
    Name: "ABDUL QUAIYUM ANSARI",
    Position:"Vice Chair,  IEEE India Council",
    Organization: "Jamia Millia Islamia, New Delhi",
    Country: "India"
  },
  {
    Name: "M N HODA",
    Position:"Chairperson, IEEE Delhi Section, India",
    Organization: "Bharati Vidyapith Institute of Computer Application and Management, New Delhi",
    Country: "India"
  }
]


 const General_chair = [
  {
    Name: "D. K. LOBIYAL",
    Organization: "Jawaharlal Nehru University, New Delhi",
    Country: "India"
  },
  {
    Name: "R. S. YADAV",
    Organization: "Motilal Nehru National Institute of Technology Allahbad, Prayagraj",
    Country: "India"
  },
  {
    Name: "KHAIROL AMALI BIN AHMAD",
    Organization: "National Defence University of Malasysia, Kem Perdana",
    Country: "Malasysia"
  }
];

const conference_chair = [
  {
    Name: "KARAN SINGH",
    Organization: "Jawaharlal Nehru University",
    Country: "India"
  },
  
  {
    Name: "BHAVNESH KUMAR",
    Organization: "NSUT, New Delhi",
    Country: "India"
  },
  {
    Name: "RATAN LAL",
    Organization: "Northwest Missouri State University",
    Country: "USA"
  }
  
];


const Conveners = [
  
  {
    Name: "SUSHIL KUMAR",
    Organization: "Jawaharlal Nehru University",
    Country: "India"
  },
  {
    Name: "SERGEY BEZZATEEV",
    Organization: "Itmo University",
    Country: "Russia"
  },
  {
    Name: "ALI AHMADIAN",
    Organization: "Central Queensland University",
    Country: "Australia"
  }
];

const Technical_program_chairs = [
  {
      Name: "ADITI SHARAN",
      Organization: "Jawaharlal Nehru University",
      Country: "India"
  },

  {
      Name: "RAJAT SADHUKHAN",
      Organization: "Indian Institute of Technology Roorkee",
      Country: "India"
  },
  {
      Name: "ROSILAH BINTI HASSAN",
      Organization: "Universiti Kebangsaan Malaysia",
      Country: "Malaysia"
  },
];

// const Technical_program_chairs = [

//   {
//       Track:"Track 1: Networking and Communication",
//       Chairs: [
        
//         { 
//           Name: "SANJOY DAS", 
//           Organization: "INDIRA GANDHI NATIONAL TRIBAL UNIVERSITY", 
//           Country: "India"
//         },
//         {
//           Name: "H L MANDORIA",
//           Organization: "Govind Ballabh Pant University of Agriculture & Technology, Pantnagar, UK",
//           Country: "India"
//         },
//       ]
//   },
//   {
//       Track:"Track 2: Smart Computing",
//       Chairs: [
//         {
//           Name: "ADITI SHARAN",
//           Organization: "Jawaharlal Nehru University",
//           Country: "India"
//         },
//         {
//           Name: "ANSHUL VARSHNEY",
//           Organization: "National Physical Laboratory, Delhi",
//           Country: "India"
//         },
        
        
//       ]
//   },
//   {
//       Track:"Track 3: Cryptography",
//       Chairs: [

//         {
//           Name: "RAJAT SADHUKHAN",
//           Organization: "Indian Institute of Technology Roorkee",
//           Country: "India"
//         },
//         {
//           Name: "AMIT KUMAR AWASTHI",
//           Organization: "Gautam Buddha University",
//           Country: "India"
//         },
        
        
//       ]
//   },
//   {
//       Track:"Track 4: Blockchain",
//       Chairs: [
//          { 
//           Name: "KHALEEL AHMAD", 
//           Organization: "MAULANA AZAD NATIONAL URDU UNIVERSITY, HYDERABAD", 
//           Country: "India" 
//         },
//         {
//           Name: "MANSAF ALAM",
//           Organization: "Jamia Millia Islamia, New Delhi",
//           Country: "India"
//         },
        
        
        
//       ]
//   },
//   {
//       Track:"Track 5:Cyber Security",
//       Chairs: [
//         { 
//           Name: "ANURAG JAIN", 
//           Organization: "GURU GOBIND SINGH INAPRASTHA UNIVERSITY", 
//           Country: "India" 
//         },
        
//         {
//           Name: "SHAILENA PRATAP SINGH",
//           Organization: "Central University of Rajastan, Rajasthan",
//           Country: "India"
//         },
//         {
//           Name: "R. K. DWIVEDI",
//           Organization: "TMU, Moradabad",
//           Country: "India"
//         }
//       ]
//   },
//   {
//       Track:"Track 6: Intelligent System",
//       Chairs: [

//         {
//           Name: "VIVEK SRIVASTVA",
//           Organization: "NIT Uttarakhand",
//           Country: "India"
//         },
       
//         { 
//           Name: "PARMA NAND ASTYA", 
//           Organization: "SHARDA UNIVERSITY", 
//           Country: "India" 
//         },
//         {
//           Name: "ROSILAH BINTI HASSAN",
//           Organization: "Universiti Kebangsaan Malaysia",
//           Country: "Malaysia"
//         },
        
//       ]
//   },
//   {
//       Track:"Track 7: AI Based Security",
//       Chairs: [
//         {
//           Name: "SHIKHAR VERMA",
//           Organization: "Kochi University of Technology",
//           Country: "Japan"
//         },
        
//         { 
//           Name: "MANOJ KUMAR GUPTA", 
//           Organization: "SMVD, NEW DELHI", 
//           Country: "India" 
//         },
//         {
//           Name: "ARVIND DAGUR",
//           Organization: "GALGOTIAS UNIVERSITY",
//           Country: "INDIA"
//         },
//       ]
//   },
//   {
//       Track:"Track 8: Quantum Computing Security",
//       Chairs: [
//         { 
//           Name: "OMPRAKASH KAIWARTYA", 
//           Organization: "Nottingham Trent University", 
//           Country: "UK" 
//         },
//         { 
//           Name: "B. B. SAGAR", 
//           Organization: "HBTU, KANPUR, U.P.", 
//           Country: "India" 
//         },
        
//         {
//           Name: "MANISH GUPTA",
//           Organization: "University of Technology Sydney",
//           Country: "Australia"
//         },
//       ]
//   },
  
// ];


const Fund_raising_committee = [
  {
    Name: "SAURABH KUMAR SHARMA",
    Organization: "Jawaharlal Nehru University, New Delhi",
    Country: "India"
  },
  {
    Name: "SMITA",
    Organization: "Galgotias University, Greater Noida",
    Country: "India"
  },
  // {
  //   Name: "DEEPIKA SAINI",
  //   Organization: "GraphicEra Deemed to be University, Dehradun",
  //   Country: "India"
  // },
  {
    Name: "BHOOPESH SINGH BHATI",
    Organization: "IIIT Sonepat",
    Country: "India"
  },
  {
    Name: "RABINDRA K. BARIK",
    Organization: "KIIT University, Bhubaneswar, Odisha",
    Country: "India"
  }
];


const Registration_committee = [
  {
    Name: "ASUTOSH SRIVASTAVA",
    Organization: "Jawaharlal Nehru University",
    Country: "India"
  },
  {
    Name: "R. P. OJHA",
    Organization: "PANIPAT INSTITUTE OF ENGINEERING & TECHNOLOGY",
    Country: "India"
  },
  {
    Name: "DEEPIKA SAINI",
    Organization: "GraphicEra Deemed to be University, Dehradun",
    Country: "India"
  },
  // {
  //   Name: "DHIRENA KUMAR SHUKLA",
  //   Organization: "Galgotias University, Greater Noida",
  //   Country: "India"
  // }
  {
    Name: "ANIL K SAGGAR",
    Organization: "Sharda University, Greater Noida",
    Country: "India"
  }
];

const Finance_committee = [
  {
    Name: "JASRAJ MEENA",
    Organization: "Jawaharlal Nehru University, New Delhi",
    Country: "India"
  }, 
  {
    Name: "VINAY PATHAK",
    Organization: "IIIT Sonepat, Haryana",
    Country: "India"
  },
  {
    Name: "SUBRATA SAHANA",
    Organization: "Sharda University, Greater Noida",
    Country: "India"
  },
  {
    Name: "VIKRANT SHARMA",
    Organization: "Graphic Era Hill University, Dehradun, UK",
    Country: "India"
  }
  // {
  //   Name: "SHABIR ALI",
  //   Organization: "Galgotias University, Greater Noida",
  //   Country: "India"
  // }
];

const Publication_committee = [
  {
    Name: "INDIVAR GUPTA",
    Organization: "Scientific Analysis Group, DO",
    Country: "India"
  },
  // {
  //   Name: "SUNIL K SINGH",
  //   Organization: "CCET (Degree Wing), Panjab University, Chandigarh",
  //   Country: "India"
  // },
  {
    Name: "MANISHA MANJUL",
    Organization: "G. B. Pant DSEU Campus-I, New Delhi",
    Country: "India"
  },
  {
    Name: "AYESHA CHOUDHARY",
    Organization: "Jawaharlal Nehru University, New Delhi",
    Country: "India"
  },
  {
    Name: "JAIME LLORET MAURI",
    Organization: "Universidad Politecnica de Valencia",
    Country: "Spain"
  },
  {
    Name: "SATVIK VATS",
    Organization: "Madan Mohan Malaviya University of Technology, Gorakhpur, U.P.",
    Country: "India"
  },
  {
    Name: "TAYYAB KHAN",
    Organization: "IIIT Sonepat, Haryana",
    Country: "India"
  },
  {
    Name: "MAHENDRA KUMAR JANGIR",
    Organization: "GPC Sikar, Departed of Technical Education Rajasthan",
    Country: "India"
  },
  // {
  //   Name: "INANATH CHATTERJEE",
  //   Organization: "Manchester Metropolitan University, Manchester",
  //   Country: "United Kingdom"
  // },
  // {
  //   Name: "SOHEIL SALAHSHOUR",
  //   Organization: "Bahcesehir University, Istanbul",
  //   Country: "Turkey"
  // },
  // {
  //   Name: "NITIN SHUKLA",
  //   Organization: "Bennett University, Greater Noida",
  //   Country: "India"
  // }
];

const Poster_and_demonstration_committee = [
  {
    Name: "BUDDHA SINGH",
    Organization: "Jawaharlal Nehru University, New Delhi",
    Country: "India"
  },
  {
    Name: "ANIL KUMAR YADAV",
    Organization: "chaudhary charan singh university, UP",
    Country: "India"
  },
  {
    Name: "ZAFAR U. AHMED",
    Organization: "Lebanese American University",
    Country: "USA"
  },
  {
    Name: "AL-SAKIB KHAN PATHAN",
    Organization: "United International University (UIU)",
    Country: "Bangladesh"
  } 
];

const Event_management_committee = [
  {
    Name: "SACHIN BALKRUSHNA JADHAV",
    Organization: "Jawaharlal Nehru University",
    Country: "India"
  },
  {
    Name: "POONAM AGARWAL",
    Organization: "Jawaharlal Nehru University",
    Country: "India"
  },
  {
    Name: "TIRTHANKAR GAYEN",
    Organization: "Jawaharlal Nehru University, New Delhi",
    Country: "India"
  },
  {
    Name: "ANUJ SACHAN",
    Organization: "Jawaharlal Nehru University, New Delhi",
    Country: "India"
  },
  {
    Name: "SUBHASH CHANDRA PATEL",
    Organization: "Jawaharlal Nehru University, New Delhi",
    Country: "India"
  },
  {
    Name: "ARUN PRAKASH",
    Organization: "Jawaharlal Nehru University, New Delhi",
    Country: "India"
  },
  {
    Name: "PRIYA GUPTA",
    Organization: "Jawaharlal Nehru University, New Delhi",
    Country: "India"
  },
  {
    Name: "INTYAZ ALAM",
    Organization: "Bihar Engineering University",
    Country: "India"
  },
  {
    Name: "AJAI KUMAR",
    Organization: "Meerut Institute of Engineering & Technology (MIET)",
    Country: "India"
  },
  {
    Name: "AKANKSHA",
    Organization: "KIET Group Of Institutions, Delhi-NCR, Ghaziabad",
    Country: "India"
  },
  {
    Name: "PRIYANKA",
    Organization: "National Institute of Technology Hamirpur ",
    Country: "India"
  },
  {
    Name: "AJEET SINGH",
    Organization: "Galgotias University, Greater Noida",
    Country: "India"
  },
  {
    Name: "RAJEEV ANAND SAHU",
    Organization: "Bosch Global Software Technologies",
    Country: "India"
  },
  {
          Name: "ARVIND DAGUR",
          Organization: "GALGOTIAS UNIVERSITY",
          Country: "INDIA"
  },
  
  {
    Name: "KUMAR RAHUL",
    Organization: "NIFTEM Sonepat",
    Country: "India"
  },
  { 
    Name: "RAM SHRINGAR RAW", 
    Organization: "NSUT, DELHI", 
    Country: "India" 
  },
  {
    Name: "RAVI SHANKAR SHUKLA",
    Organization: "Saudi Electronic University",
    Country: "Saudi Arabia"
  },
  {
    Name: "AJAY KUMAR",
    Organization: "Central University of Himachal Pradesh, Dharamshala",
    Country: "India"
  },
  {
    Name: "GAURAV RAJ",
    Organization: "Sharda University, Greater Noida",
    Country: "India"
  },
  { 
    Name: "KALPANA SINGH", 
    Organization: " Worldline", 
    Country: "France" 
  },
  {
    Name: "SANOJ KUMAR",
    Organization: "Indian Institute of Technology Roorkee, U.K.",
    Country: "India"
  },
  {
    Name: "NAVEEN KUMAR GUPTA",
    Organization: ". B. R. Ambedkar National Institute of Technology, Jalandhar",
    Country: "India"
  },
  {
    Name: "DAVID TANIAR",
    Organization: "Monash University",
    Country: "Australia"
  },
  {
    Name: "AKHILESH KUMAR",
    Organization: "Galgotias University, Greater Noida",
    Country: "India"
  },
  {
    Name: "REENA KASANA",
    Organization: "University of Delhi",
    Country: "India"
  },
  {
    Name: "M K SHARMA",
    Organization: "Amrapali University, Haldwani",
    Country: "India"
  }
];


const Web_committee = [
  {
    Name: "YOGENDRA MEENA",
    Organization: "Jawaharlal Nehru University, New Delhi",
    Country: "India"
  },
  {
    Name: "LE HOANG SON",
    Organization: "Vietnam National University, Hanoi",
    Country: "Vietnam"
  },
  {
    Name: "ASHISH KHANNA",
    Organization: "CSED, MAIT, Delhi",
    Country: "India"
  },
  {
    Name: "S SANJIB KUMAR",
    Organization: "Indian Institute of Roorkee",
    Country: "India"
  }
];


const Publicity_and_public_relations_committee = [
  {
    Name: "POONGUZHALI N",
    Organization: "Jawaharlal Nehru University, New Delhi",
    Country: "India"
  },
  {
    Name: "YOGENDRA MOHAN",
    Organization: "North Eastern Regional Institute of Science and Technology, Itanagar",
    Country: "India"
  },
  // {
  //   Name: "SHEHZAD ASHRAF CHAUDHRY",
  //   Organization: "Abu Dhabi University (ADU)",
  //   Country: "UAE"
  // },
  {
    Name: "AMANDEEP",
    Organization: "GJUST, Hisar",
    Country: "India"
  },
  {
    Name: "PAWAN SINGH MEHRA",
    Organization: "Delhi Technological University, New Delhi",
    Country: "India"
  }
];


const Special_session_committee = [
  {
    Name: "VIKAS MITTAL",
    Organization: "Jawaharlal Nehru University, New Delhi",
    Country: "India"
  },
  {
    Name: "NUR IZURA UDZIR",
    Organization: "University of Putra Malaysia",
    Country: "Malaysia"
  },
  {
    Name: "MOHAMMAD SHARIQ",
    Organization: "United Arab Emirates University, Al Ain, Abu Dhabi",
    Country: "UAE"
  },
  {
    Name: "UPASANA DOHARE",
    Organization: "Galgotias University, UP",
    Country: "India"
  },
  {
    Name: "ALOK KATIYAR",
    Organization: "Galgotias University, Greater Noida",
    Country: "India"
  }
];


const Advisory_committee = [
  {
    Name: "BHARAT K. BHARGAVA",
    Organization: "Department of Computer Sciences, Purdue University, Indiana",
    Country: "USA"
  },
  {
    Name: "M. N DOJA",
    Organization: "Chairman, Governing Body, College of Vocational Studies, University of Delhi; Former Director, IIIT Sonepat",
    Country: "India"
  },
  {
    Name: "RAJEEV TRIPATHI",
    Organization: "Motilal Nehru National Institute of Technology Allahabad, Prayagraj",
    Country: "India"
  },
  {
    Name: "SONAJHARIA MINZ",
    Organization: "School of Computer & Systems Sciences, JNU, New Delhi",
    Country: "India"
  },
  {
    Name: "ZAHEERUDDIN",
    Organization: "Jamia Millia Islamia, New Delhi",
    Country: "India"
  },
  {
    Name: "R. K. AGRAWAL",
    Organization: "School of Computer & Systems Sciences, JNU, New Delhi",
    Country: "India"
  },
  {
    Name: "A. HANAN ABDULLAH",
    Organization: "Faculty of Computing, University Technology Malaysia, Johor Bahru",
    Country: "Malaysia"
  },
  {
    Name: "D. P. VIDYARTHI",
    Organization: "School of Computer & Systems Sciences, JNU, New Delhi",
    Country: "India"
  },
  {
    Name: "AIME-LAY-EKUAKILLE",
    Organization: "University of Salento, Lecce",
    Country: "Italy"
  },
  {
    Name: "MANOB SAIKIA",
    Organization: "University of Memphis",
    Country: "USA"
  },
  {
    Name: "T. V. VIJAY KUMAR",
    Organization: "School of Computer & Systems Sciences, JNU, New Delhi",
    Country: "India"
  },
  {
    Name: "VIR BAHADUR SINGH",
    Organization: "School of Computer & Systems Sciences, JNU, New Delhi",
    Country: "India"
  },
  {
    Name: "RATNESHWER",
    Organization: "School of Computer & Systems Sciences, JNU, New Delhi",
    Country: "India"
  },
  
  {
    Name: "PIYUSH PRATAP SINGH",
    Organization: "School of Computer & Systems Sciences, JNU, New Delhi",
    Country: "India"
  },
  {
    Name: "BASHIR ALAM",
    Organization: "Jamia Millia Islamia, New Delhi",
    Country: "India"
  },
  { 
    Name: "S. K SINGH", 
    Organization: "CCET, CHANDIGARH, PUNJAB", 
    Country: "India" 
  },
  {
    Name: "KISHORI LAL BANSAL",
    Organization: "Himachal Pradesh University",
    Country: "India"
  }
];


const InternationalTPC = [
  { Name: "ALAIN BRETTO", Organization: "Computer Science Department, University of Caen", Country: "France" },
  { Name: "ATIF AZAD", Organization: "Ericsson Telekommunikation GmbH & Co KG", Country: "Germany" },
  { Name: "RAFIK HAMZA", Organization: "Tokyo International University (TIU)", Country: "Japan" },
  { Name: "CHENG-CHI LEE", Organization: "Fu Jen Catholic University", Country: "Taiwan" },
  { Name: "MOHAMMAD SHOJAFAR", Organization: "University of Surrey, Guildford", Country: "United Kingdom" },
  { Name: "ARIJIT KARATI", Organization: "National Sun Yat-sen University", Country: "Taiwan" },
  { Name: "KHALID MAHMOOD", Organization: "National Yunlin University of Science and Technology", Country: "Taiwan" },
  { Name: "MADHUSANKA LIYANAGE", Organization: "School of Computer Science, University College Dublin", Country: "Ireland" },
  { Name: "CARLOS BECKER WESTPHALL", Organization: "IS, Federal University of Santa Catarina", Country: "Brazil" },
  { Name: "SHABANA UROOJ", Organization: "Princess Nourah bint Abdulrahman University", Country: "Saudi Arabia" },
  { Name: "DIMITRIOS A. KARRAS", Organization: "National and Kapodistrian University of Athens", Country: "Greece" },
  { Name: "EISUKE KITA", Organization: "CSS, School of IS, Nagoya University", Country: "Japan" },
  { Name: "GAUTAM TIWARI", Organization: "Accenture LLP, Bloomington Illinois", Country: "USA" },
  { Name: "GUOYI PENG", Organization: "COE, Nihon University, Fukushima", Country: "Japan" },
  { Name: "HASMUKH MORARJI", Organization: "EE & CS, Queensland University of Technology, Brisbane", Country: "Australia" },
  { Name: "H. J. KAMARUZAMAN JUSOFF", Organization: "University of Putra Malaysia, Ehsan", Country: "Malaysia" },
  { Name: "IMRAN BASHIR BHATTI", Organization: "Red-Database-Security GmbH", Country: "Germany" },
  { Name: "JAY SINGH", Organization: "Chonbuk National University, Jeonju, Jeonbuk", Country: "Korea" },
  { Name: "MADAN SINGH", Organization: "National University of Lesotho", Country: "Lesotho" },
  { Name: "MAODE MA", Organization: "College of Engineering, Qatar University", Country: "Qatar" },
  { Name: "MICHAEL COYLE", Organization: "East Carolina University, Greenville", Country: "USA" },
  { Name: "NEHA GUPTA", Organization: "Dell, Phoenix", Country: "USA" },
  { Name: "NIKA RAATIKAINEN", Organization: "ES, University of Eastern Finland", Country: "Finland" },
  { Name: "MOHAMMAD HASHIM", Organization: "Hughes Network System GmbH", Country: "Germany" },
  { Name: "MOSTAFA FOUDA", Organization: "GSIS, Tohoku University", Country: "Japan" },
  { Name: "NALIN SARDA", Organization: "School of Engineering and Science, Victoria University", Country: "Australia" },
  { Name: "RASHIDALI", Organization: "Taif University", Country: "Saudi Arabia" },
  { Name: "SAIKISHOPR ELANGOVAN", Organization: "Chief IO & NE, Techno Forum Software Solutions", Country: "Australia" },
  { Name: "SANDEEP LOHANI", Organization: "Department of Economic Security", Country: "USA" },
  { Name: "SANJAY AGARWAL", Organization: "Cypress Semiconductor", Country: "Taiwan" },
  { Name: "SANJAY SINGH", Organization: "EADS Deutschland GmbH", Country: "Germany" },
  { Name: "SHAHID AKRAM", Organization: "Quipi GmbH", Country: "Germany" },
  { Name: "SHAZIL KAMAL SHAH", Organization: "CDM Australia", Country: "Australia" },
  { Name: "YUE CAO", Organization: "Wuhan University", Country: "China" },
  { Name: "MIKA RAATIKAINEN", Organization: "ES, University of Eastern Finland", Country: "Finland" },
  { Name: "TARUN JAGANI", Organization: "Scalaris AG", Country: "Germany" },
  { Name: "THTIKAN BOONKANG", Organization: "Faculty of Engineering, Ubon Ratchathani University", Country: "Thailand" },
  { Name: "V. LAKSHMI NARASIMHAN", Organization: "CSE, East Carolina University, Greenville", Country: "USA" },
  { Name: "VIRENA C. BHAVSAR", Organization: "University of New Brunswick, Fredericton", Country: "Canada" },
  { Name: "WINFRIED E. KUEHNHAUSER", Organization: "Computer Science, Technical University of Ilmenau", Country: "Germany" },
  { Name: "ZIYAD AL-KHINALIE", Organization: "Information Technology, Multimedia University", Country: "Malaysia" },
  { Name: "KHANDAKAR RABBI AHMED", Organization: "IUBAT - International University of Business Agriculture and Technology, Dhaka", Country: "Bangladesh" },
  { Name: "Vatesh Pasrija", Organization: "Meta Platforms Inc, Bellevue", Country: "USA" },
  { Name: "SUKANTH KORKANTI", Organization: "LSEG, Sydney, Australia", Country: "Australia" },
  { Name: "MANISH GUPTA", Organization: "University of Sunshine Coast, Australia", Country: "Australia" },
  { Name: "PRASANNA SANKARAN", Organization: "General Motors Financial, Texas, USA", Country: "USA" },
  { Name: "Kiran Polimetla", Organization: "Adobe, Austin, TX", Country: "USA" },
  { Name: "Arifur Rahman", Organization: "Khulna University of Engineering & Technology, Bangladesh", Country: "Bangladesh" },
  { Name: "Rajasekaran S", Organization: "University of Technology and Applied Sciences, Ibri", Country: "Oman" },
  { Name: "Saurav Bhattacharya", Organization: "The New World Foundation", Country: "USA" },
  { Name: "Anusha Reddy Narapureddy", Organization: "Apple Inc", Country: "USA" },
  { Name: "Devendra Singh Parmar", Organization: "Discover Financial Services, Chicago", Country: "USA" },
 
  { Name: "Shivaraj Yanamandram Kuppuraju", Organization: "Amazon.com Inc.", country: "USA" },
  { Name: "Abhinav Gautam", Organization: "Tyndall National Institute, Cork", country: "Ireland" },
  { Name: "Anirudh Khanna", Organization: "Pacific Gas & Electric, CA", country: "USA" },
  { Name: "Dinesh Kumar", Organization: "Oracle America Inc., Apex", country: "USA" },
  { Name: "Chandrashekhar Moharir", Organization: "HCL America, Dallas", country: "USA" },
  { Name: "Gauri Shankar", Organization: "LUT-University", country: "Finland" }
];



const nationalTPC = [
  { name: "ABHAY KUMAR", affiliation: "INDIAN INSTITUTE OF INFORMATION TECHNOLOGY AGARTALA", country: "India" },
  { name: "AMBIKA GUPTA", affiliation: "Galgotias University", country: "India" },
  { name: "PRASHANT JOHRI", affiliation: "Galgotias University, Greater Noida", country: "India" },
  { name: "ABHIJEET MAITRA", affiliation: "IIT Guwahati", country: "India" },
  { name: "AJAY KUMAR SHARMA", affiliation: " B R AMBEDKAR NATIONAL INSTITUTE OF TECHNOLOGY JALANDHAR, PUNJAB", country: "India" },
  { name: "JALAJ SHARMA", affiliation: "G.B PANTNAGAR UNIVERSITY", country: "India" },
  { name: "APARAJITA OJHA", affiliation: "Director, IIIT Jabalpur, M.P.", country: "India" },
  { name: "B. RAMADOSS", affiliation: "CSE, NIT, Tiruchirappalli, T.N.", country: "India" },
  { name: "B. B. AMBERKER", affiliation: "CSE, NIT Warangal, A.P.", country: "India" },
  { name: "RAJENA KUMAR", affiliation: "JAMIA MILLIA ISLAMIA, DELHI", country: "India" },
  { name: "SAHADE PADHYE", affiliation: "MOTILAL NEHRU NATIONAL INSTITUTE OF TECHNOLOGY ALLAHABAD", country: "India" },
  { name: "DHEERENA MISHRA", affiliation: "MAULANA AZAD NATIONAL INSTITUTE OF TECHNOLOGY (MANIT), BHOPAL", country: "India" },
  { name: "BRAHMJIT SINGH", affiliation: "ECE, NIT Kurukshetra", country: "India" },
  { name: "CHALLA RAMA KRISHNA", affiliation: "CSE, NITTTR (Ministry of HRD)", country: "India" },
  { name: "RAJESH MISHRA", affiliation: "G.B.U, GREATER NOIDA", country: "India" },
  { name: "DHARMENDER KUMAR", affiliation: "AI AND DS, GJUST, HISAR", country: "India" },
  { name: "NAVAID ZAFAR RIZVI", affiliation: "G.B.U, GREATER NOIDA", country: "India" },
  { name: "MAYANK SINGH", affiliation: "SCHOOL OF ENGINEERING, G.B.U, GREATER NOIDA", country: "India" },
  { name: "ABDUL WAHID", affiliation: "MAULANA AZAD NATIONAL URDU UNIVERSITY, HYDERABAD", country: "India" },
  { name: "NANHAY SINGH", affiliation: "NETAJI SUBHAS UNIVERSITY OF TECHNOLOGY", country: "India" },
  { name: "SARTAJ UL HASAN", affiliation: "INDIAN INSTITUTE OF TECHNOLOGY JAMMU", country: "India" },
  { name: "D.K. YADAV", affiliation: "NIT JAMSHEDPUR", country: "India" },
  { name: "M.M. SUFYAN BEG", affiliation: "JAMIA MILLIA ISLAMIA UNIVERSITY, NEW DELHI", country: "India" },
  { name: "N.S. MURTHY", affiliation: "JVRSEC, KANURU, ANDHRA PRADESH", country: "India" },
  { name: "S.K. CHATURVEDI", affiliation: "INDIAN INSTITUTE OF TECHNOLOGY, KHARAGPUR", country: "India" },
  { name: "S.S. PATNAYAK", affiliation: "NITTTR Chandigarh", country: "India" },
  { name: "BHUPERA GUPTA", affiliation: "IIIT JABALPUR, M.P.", country: "India" },
  { name: "D.K. MISHRA", affiliation: "S.G.S.I.T.S., Indore M.P.", country: "India" },
  { name: "M.P. SEBASTIAN", affiliation: "IIM KOZHIKODE", country: "India" },
  { name: "INANIL SEN GUPTA", affiliation: "CSE, Indian Institute of Technology, Kharagpur", country: "India" },
  { name: "K. B. MISHRA", affiliation: "IIT Kharagpur", country: "India" },
  { name: "MADHU JAIN", affiliation: "INDIAN INSTITUTE OF TECHNOLOGY ROORKEE, U.K.", country: "India" },
  { name: "MAHESH CHANA", affiliation: "BIT Mesra, Ranchi", country: "India" },
  { name: "MOHD KAMIL", affiliation: "University Polytechnic CS, Jamia Millia Islamia, New Delhi", country: "India" },
  { name: "N. S. MURTHY", affiliation: "ECE, NIT, Warangal", country: "India" },
  { name: "P. VENKATARAM", affiliation: "ECE, IISc, Bangalore", country: "India" },
  { name: "ARVIND", affiliation: "HANSRAJ COLLEGE (DELHI UNIVERSITY)", country: "India" },
  
  { name: "S. H. ABBAS MEHDI", affiliation: "STPI, Ministry of IT, Govt. of India, Noida", country: "India" },
  { name: "S. TUSHIR", affiliation: "DEEYA ENERGY INDIA, GURGAON", country: "India" },
  { name: "AJEET K. PANDEY", affiliation: "COGNIZANT TECHNOLOGY SOLUTIONS, HYDERABAD", country: "India" },
  { name: "MOHD. ASHRAF SAIFI", affiliation: "MAULANA AZAD NATIONAL URDU UNIVERSITY, HYDERABAD", country: "India" },
  // { name: "KHALEEL AHMAD", affiliation: "MAULANA AZAD NATIONAL URDU UNIVERSITY, HYDERABAD", country: "India" },
  
  { name: "ANISH MATHURIA", affiliation: "DA-IICT, GUJARAT", country: "India" },
  { name: "P. C. JAIN", affiliation: "C-DAC Centre, Noida", country: "India" },
  { name: "P. C. JHA", affiliation: "Delhi University, New Delhi", country: "India" },
  { name: "P. K. SINGH", affiliation: "IITM Gwalior (M.P.)", country: "India" },
  { name: "PREETAM KUMAR", affiliation: "IIT Patna", country: "India" },
  { name: "RAJENA K. ASTHANA", affiliation: "SDS Software, Noida", country: "India" },
  { name: "RAKESH MAHESHWAR", affiliation: "STQC, Ministry of Communication & IT, New Delhi", country: "India" },
  { name: "RAMA MURTHY G.", affiliation: "IIIT Hyderabad", country: "India" },
  { name: "RAMESH B. GHODGAONKAR", affiliation: "EE, MANIT Bhopal", country: "India" },
  { name: "RANJIT BISWAS", affiliation: "CSE, Jamia Hamdard, New Delhi", country: "India" },
  { name: "S. B. SABBARWAL", affiliation: "IIT Delhi", country: "India" },
  { name: "S. S. RAJPUT", affiliation: "NPL, New Delhi", country: "India" },
  { name: "SANJEEV TOKEKAR", affiliation: "Devi Ahilya University, Indore", country: "India" },
  { name: "UDAISHANKER", affiliation: "CSE, MMMEC Gorakhpur", country: "India" },
  { name: "AKHILESH R. UPADHYAY", affiliation: "SIRT, Bhopal", country: "India" },
  { name: "ALEEM ALI", affiliation: "University Polytechnic CS, Jamia Millia Islamia, New Delhi", country: "India" },

  ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  { name: "GUNJAN VERMA", affiliation: "GL BAJAJ INSTITUTE OF TECHNOLOGY AND MANAGEMENT, GREATER NOIDA", country: "India" },
  { name: "AAMIR KHAN", affiliation: "GRAPHIC ERA HILL UNIVERSITY, DEHRADUN", country: "India" },
  { name: "ASHOK KUMAR SINGH", affiliation: "GALGOTIAS COLLEGE OF ENGINEERING AND TECHNOLOGY, GREATER NOIDA", country: "India" },
  { name: "KANIKA SHARMA", affiliation: "LOVELY PROFESSIONAL UNIVERSITY, PHAGWARA", country: "India" },
  { name: "TIYAS SARKAR", affiliation: "LOVELY PROFESSIONAL UNIVERSITY", country: "India" },
  { name: "SANTOSH KUMAR VERMA", affiliation: "JK LAKSHMIPAT UNIVERSITY, JAIPUR", country: "India" },
  { name: "SARVESH MAURYA", affiliation: "BENNETT UNIVERSITY, GREATER NOIDA", country: "India" },
  { name: "AJIT KUMAR SINGH YADAV", affiliation: "North Eastern Regional Institute of Science and Technology, Itanagar", country: "India" },
  { name: "Ramkumar MO", affiliation: "IFET COLLEGE OF ENGINEERING", country: "India" },
  { name: "DEEPENA RASTOGI", affiliation: "School of Computer Science and Engineering, IILM University, Greater Noida", country: "India" },
  { name: "PACHIGOLLA VENKATA SURESH", affiliation: "IGNOU, NEW DELHI", country: "India" },
  { name: "AMULYA MALLOLA", affiliation: "IBM BENGALURU", country: "India" },
  { name: "Y KALYAN CHAKRAVARTI", affiliation: "Siddhartha Academy of Higher Education, Vijayawada", country: "India" },
  { name: "GAURVI SHUKLA", affiliation: "NATIONAL POST GRADUATE COLLEGE, LUCKNOW", country: "India" },
  { name: "Christopher Francis Britto", affiliation: "Mahatma Gandhi University, Meghalaya", country: "India" },
  { name: "SHIVANG", affiliation: "CHANDIGARH UNIVERSITY, MOHALI", country: "India" },
  { name: "MANJU VERMA", affiliation: "SHARDA UNIVERSITY GREATER NOIDA", country: "India" },
  { name: "NUPA RAM CHAUHAN", affiliation: "TEERTHANKER MAHAVEER UNIVERSITY", country: "India" },
  { name: "INDU DOHARE", affiliation: "Motilal Nehru National Institute of Technology Allahabad, Prayagraj", country: "India" },
  { name: "V. SOWMYA DEVI", affiliation: "SREENIDHI INSTITUTE OF SCIENCE AND TECHNOLOGY, HYDERABAD", country: "India" },
  { name: "RAJ SHEKHAR", affiliation: "BENNETT UNIVERSITY, GREATER NOIDA", country: "India" },
  { name: "ZULFIKAR ALI ANSARI", affiliation: "SYMBIOSIS INSTITUTE OF TECHNOLOGY, SYMBIOSIS INTERNATIONAL University, Pune", country: "India" },
  { name: "Pragya Siddhi", affiliation: "GL Bajaj Institute of Technology and Management Greater Noida", country: "India" },
  { name: "AYASHKANT MISHRA", affiliation: "CV RAMAN GLOBAL UNIVERSITY, BHUBANESWAR", country: "India" },
  
  { name: "RAJEEV SHARMA", affiliation: "Chandigarh Engineering College- CGC, Lanan, Mohali", country: "India" },
  { name: "ARUN KUMAR MAURYA", affiliation: "INDIAN INSTITUTE OF TECHNOLOGY ROORKEE UTTARAKHAND", country: "India" },
  { name: "MD ARQUAM", affiliation: "IIIT SONEPAT", country: "India" },
  { name: "NARENA KHATRI", affiliation: "MANIPAL INSTITUTE OF TECHNOLOGY, MANIPAL", country: "India" },
  { name: "Brijesh Kumar", affiliation: "Indira Gandhi Delhi Technical University for Women, Delhi", country: "India" },
  { name: "SONAM GUPTA", affiliation: "AJAY KUMAR GARG ENGINEERING COLLEGE, GHAZIABAD", country: "India" },
  { name: "RASHMI SHARMA", affiliation: "Noida institute of engineering and technology, GREATER NOIDA", country: "India" },
  { name: "MADHAVI", affiliation: "BENNETT UNIVERSITY", country: "India" },
  { name: "ROHIT SHORYA", affiliation: "Department of Computer Science, University of Delhi", country: "India" },
  { name: "RUPA RANI", affiliation: "AJAY KUMAR GARG ENGINEERING COLLEGE, GHAZIABAD", country: "India" },
  { name: "ANUBHAV KUMAR PRASAD", affiliation: "UNITED INSTITUTE OF TECHNOLOGY, PRAYAGRAJ", country: "India" },

  { name: "NATVAR PATEL", affiliation: "Smt. B.K. Mehta IT Centre BCA College, Palanpur", country: "India" },
  { name: "VISHWAS MISHRA", affiliation: "SWAMI VIVEKANAND SUBHARTI UNIVERSITY, MEERUT", country: "India" },
  
  { name: "NIDHI TIWARI", affiliation: "SHRI RAMSWAROP MEMORIAL UNIVERSITY, BARABANKI", country: "India" },
  { name: "SUDHANSH SHARMA", affiliation: "SOCIS-IGNOU, NEW DELHI", country: "India" },
  { name: "Tarak Hussain", affiliation: "Department of AI and DS Koneru Lakshmaiah Education Foundation, Vaddeswaram, Andhra Pradesh", country: "India" },
  { name: "CHANDANI SHARMA", affiliation: "MMICTBM (MCA) MAHARISHI MARKANDESHWAR (DEEMED TO BE UNIVERSITY) MULLANA, AMBALA, HARYANA", country: "India" },
  { name: "K.NAVAZ", affiliation: "Vel Tech Rangarajan Dr Sagunthala R&D Institute of Science and Technology, Avadi, Chennai", country: "India" },
  { name: "S.KANNADHASAN", affiliation: "STUDY WORLD COLLEGE OF ENGINEERING, COIMBATORE", country: "India" },
  { name: "AVINASH AWASTHI", affiliation: "Malaviya National Institute of Technology, Jaipur", country: "India" },
  { name: "CHANDAN BASNIWAL", affiliation: "GOVERNMENT POLYTECHNIC COLLEGE SIKAR RAJASTHAN", country: "India" },
  { name: "GAURAV KUMAR", affiliation: "GLA UNIVERSITY, MATHURA", country: "India" },
  { name: "PRIYANKA KAUSHAL", affiliation: "CHANDIGARH ENGINEERING COLLEGE -CGC, LANDRAN, PUNJAB", country: "India" },
  { name: "ABHISHEK JAIN", affiliation: "UTTARANCHAL UNIVERSITY DEHRADUN", country: "India" },
  { name: "MUDITA", affiliation: "CHITKARA UNIVERSITY, PUNJAB", country: "India" },
  { name: "DASHRATH MANE", affiliation: "VESIT, Mumbai", country: "India" },
  { name: "Manish Chhabra", affiliation: "VARDHAMAN COLLEGE OF ENGENEERING HYDERABAD TELANGANA", country: "India" },
  { name: "ASHOK KUMAR YADAV", affiliation: "RAJKIYA ENGINEERING COLLEGE AZAMGARH", country: "India" },
  { name: "Roop Lal", affiliation: "CHANDIGARH UNIVERSITY, MOHALI, PUNJAB", country: "India" },
  { name: "SHRANKHLA SAXENA", affiliation: "KIET GROUP OF INSTITUTIONS, GHAZIABAD", country: "India" },
  { name: "PRANAV SHARMA", affiliation: "JAWAHARLAL NEHRU UNIVERSITY NEW DELHI", country: "India" },
  { name: "Samta Rani", affiliation: "Sharda University, Greater Noida", country: "India" },
  { name: "Rishika Yadav", affiliation: "Graphic Era Hill University", country: "India" },
  { name: "Ajay Pratap Singh Yadav", affiliation: "IIMT COLLEGE OF ENGINEERING, GREATER NOIDA", country: "India" },
  { name: "PRAVEEN GUPTA", affiliation: "JAIPUR NATIONAL UNIVERSITY, JAIPUR", country: "India" },
  { name: "KANHAIYA KUMAR", affiliation: "GALGOTIAS COLLEGE OF ENGINEERING AND TECHNOLOGY", country: "India" },
  { name: "AAKASH MEENA", affiliation: "GOVERNMENT POLYTECHNIC COLLEGE SIKAR", country: "India" },
  { name: "SHWETA SINHA", affiliation: "NATIONAL P.G.COLLEGE, LUCKNOW", country: "India" },
  { name: "KAMLESH KUMAR GAUTAM", affiliation: "MADAN MOHAN MALAVIYA UNIVERSITY OF TECHNOLOGY GORAKHPUR", country: "India" },
  { name: "Viksith Bardia", affiliation: "Amrita Vishwa Vidyapeetham, Chennai", country: "India" },
  { name: "GAURAV KUMAR", affiliation: "IIMT COLLEGE OF ENGINEERING, GREATER NOIDA", country: "India" },
  { name: "CHATTER SINGH", affiliation: "SCHOOL OF COMPUTER APPLICATIONS, LOVELY PROFESSIONAL UNIVERSITY, JALANDHAR, PHAGWARA, PUNJAB", country: "India" },
  { name: "T S ARULANANTH", affiliation: "MLR INSTITUTE OF TECHNOLOGY, HYDERABAD", country: "India" },
  { name: "SUDHAKAR KUMAR", affiliation: "CHANDIGARH COLLEGE OF ENGINEERING AND TECHNOLOGY, CHANDIGARH", country: "India" },
  { name: "SHEETAL KAUSHIK", affiliation: "SHANTI BUSINESS SCHOOL, AHMEDABAD, affiliated to GTU", country: "India" },
  { name: "PAPENDRA KUMAR", affiliation: "G.B Pant Institute of Engineering Technology Pauri Garhwal Uttarakhand", country: "India" },

  
  { name: "ALOK KUMAR AGRAWAL", affiliation: "CHITKARA UNIVERSITY HIMACHAL PRADESH", country: "India" },
  { name: "MONIKA GUPTA", affiliation: "VEER MADHO SINGH BHANDARI UTTARAKHAND TECHNICAL UNIVERSITY, DEHRADUN", country: "India" },
  { name: "SHEETAL SHRIRANG PATIL", affiliation: "BHARATI VIDYAPEETH DEEMED TO BE UNIVERSITY COLLEGE OF ENGINEERING, PUNE", country: "India" },
  { name: "Archana Kumari", affiliation: "UPES, Dehradun", country: "India" },
  { name: "GOONJAN JAIN", affiliation: "DELHI TECHNOLOGICAL UNIVERSITY, DELHI", country: "India" },
  { name: "Rahul Singh Gautam", affiliation: "Symbiosis Institute of Business Management, Nagpur", country: "India" },
  { name: "AYESHA ANJUM", affiliation: "HKBK College of Engineering, Bengaluru", country: "India" },
  { name: "RAJENDRA KUMAR ALARIA", affiliation: "GOVERNMENT POLYTECHNIC COLLEGE SIKAR", country: "India" },
  { name: "Litty Koshy", affiliation: "SCMS School of Engineering and Technology, Ernakulam", country: "India" },
  { name: "DEVESH TIWARI", affiliation: "GRAPHIC ERA HILL UNIVERSITY, DEHRADUN", country: "India" },
  { name: "SUMAN GULIA", affiliation: "M.M INSTITUTE OF MANAGEMENT, MAHARISHI MARKANDESHWAR (DEEMED TO BE) UNIVERSITY, MULLANA, HARYANA", country: "India" },
  { name: "NIDHI GOEL", affiliation: "CHITKARA UNIVERSITY", country: "India" },
  { name: "Shaik Karimullah", affiliation: "Annamacharya University, Rajampet", country: "India" },
  { name: "SUNIL KUMAR", affiliation: "CHANDIGARH UNIVERSITY MOHALI", country: "India" },
  { name: "AJAY CHAKRAVARTY", affiliation: "TEERTHANKER MAHAVEER UNIVERSITY, MORADABAD", country: "India" },
  { name: "ANKUR MANGLA", affiliation: "MMEC, MMDU, Mullana", country: "India" },
  
  { name: "TARKESHWAR BARUA", affiliation: "ROORKEE INSTITUTE OF TECHNOLOGY, ROORKEE", country: "India" },
  { name: "Ajay Kumar", affiliation: "Bennett University, Greater Noida", country: "India" },
  { name: "Ravindra Badgujar", affiliation: "R C Patel College of Engineering and Polytechnic, Shipur", country: "India" },
  { name: "R. CHITHAMBARAMANI", affiliation: "VEL TECH RANGARAJAN  SAGUNTHALA R&D INSTITUTE OF SCIENCE AND TECHNOLOGY, CHENNAI", country: "India" },
  
  { name: "M.S.Minu", affiliation: "SRM Institute of Science and Technology, Ramapuram, Chennai", country: "India" },
  { name: "V. V. Subrahmanyam", affiliation: "School of Computer and Information Sciences, IGNOU, New Delhi", country: "India" },
  { name: "CHANDAN KUMAR", affiliation: "SUPAUL COLLEGE OF ENGINEERING", country: "India" },
  { name: "GARIMA ANAND", affiliation: "CHRIST (Deemed to be University), Delhi NCR campus", country: "India" },
  { name: "Renuka Agrawal", affiliation: "Symbiosis Institute of Technology, Pune Symbiosis International Deemed University", country: "India" },
  { name: "SATENDRA KUMAR", affiliation: "MIET MEERUT", country: "India" },
  { name: "RAJAT KISHOR VARSHNEY", affiliation: "GNIOT GREATER NOIDA", country: "India" },
  { name: "SHALINI NINORIA", affiliation: "TEERTHANKER MAHAVEER UNIVERSITY", country: "India" },
  { name: "PRASHANT UPADHYAY", affiliation: "SHARDA UNIVERSITY, Greater Noida", country: "India" },
  { name: "MOHAN VISHAL GUPTA", affiliation: "TEERTHANKER MAHAVEER UNIVERSITY, MORADABAD", country: "India" },
  { name: "GUNJAN MISHRA", affiliation: "SHRI RAMSWAROOP MEMORIAL UNIVERSITY, BARABANKI", country: "India" },
  { name: "NITIN THAPLIYAL", affiliation: "GRAPHIC ERA HILL UNIVERSITY DEHRADUN", country: "India" },
  { name: "YASHI CHAUDHARY", affiliation: "GURUKULA KANGRI (DEEMED TO BE UNIVERSITY)", country: "India" },
  { name: "Devyanee Jagadale", affiliation: "Bharati Vidyapeeth (Deemed to Be University) College of Engineering, Pune", country: "India" },

  { name: "Lokesh Malviya", affiliation: "VIT Bhopal University", country: "India" },
  { name: "Vikash Yadav", affiliation: "Government Polytechnic Bighapur Unnao", country: "India" },
  { name: "K. Rajkumar", affiliation: "SRM Institute of Science and Technology, KTR campus, Chennai, Tamil Nadu", country: "India" },
  { name: "Akhilesh Kumar Srivastava", affiliation: "ABES Engineering College, Ghaziabad", country: "India" },
  { name: "Murari Kumar Singh", affiliation: "Sharda University, Greater Noida", country: "India" },
  { name: "Puneet Thapar", affiliation: "Lovely Professional University, Phagwara, Punjab", country: "India" },
  { name: "Rajeswari M", affiliation: "Karunya University, Coimbatore", country: "India" },
  { name: "Nimmanapalli Rajesh", affiliation: "Maharaja Institute of Technology, Mysore", country: "India" },
  { name: "Rajeev Kumar Sachan", affiliation: "Allenhouse Institute of Technology, Kanpur", country: "India" },
  { name: "Md. Iqbal", affiliation: "Quantum University, Roorkee, Uttarakhand", country: "India" },
  { name: "Subhalaxmi Chakraborty", affiliation: "University of Engineering and Management, Kolkata", country: "India" },
  { name: "Aadhya A", affiliation: "Sri Venkateshwara College of Engineering, Bengaluru", country: "India" },
  { name: "Arpita Gupta", affiliation: "KLEF, Hyderabad (Off Campus)", country: "India" },
  { name: "Jaya Bansal", affiliation: "Chandigarh College of Engineering, Jhanjeri, Mohali", country: "India" },
  { name: "Krishnavamshi Ganduri", affiliation: "Woxsen University, Hyderabad", country: "India" },
  { name: "Vibha Bharilya", affiliation: "IIT Roorkee, Roorkee", country: "India" },
  { name: "Gopal Singh Rawat", affiliation: "Bennett University, Greater Noida, UP", country: "India" },
  { name: "Krishna Kumar", affiliation: "NIC, New Delhi", country: "India" },
  { name: "Shreya Yadav", affiliation: "Indian Institute of Technology Patna", country: "India" },
  { name: "Sudha Tiwari", affiliation: "Government Engineering College, Bilaspur, Chhattisgarh", country: "India" },
  { name: "V. Karthikyan", affiliation: "MEPCO Schlenk Engineering College, Sivakasi", country: "India" },
  { name: "Farheen Siddiqui", affiliation: "Jamia Hamdard, Delhi", country: "India" },
  { name: "Priyank Singhal", affiliation: "CCSIT, Teerthanker Mahaveer University, Moradabad", country: "India" },
  { name: "S. P. Maniraj", affiliation: "SRM Institute of Science and Technology, Kattankulathur Campus", country: "India" },
  { name: "B. Surendiran", affiliation: "NIT Puducherry, Karaikal", country: "India" },
  { name: "Rachna Behl", affiliation: "MRIIRS, Faridabad, Haryana", country: "India" },
  { name: "K. Riyazuddin", affiliation: "Annamacharya University, Rajampet", country: "India" },
  { name: "Rabindra Kumar Barik", affiliation: "KIIT Deemed to be University", country: "India" },
  { name: "Malik Muzamil Ishaq", affiliation: "Akal University, Bathinda", country: "India" },
  { name: "Ashok Kumar", affiliation: "Teerthanker Mahaveer University, Moradabad", country: "India" },
  { name: " Ganesh Davanam", affiliation: "Mohan Babu University, Tirupati", country: "India" },
  { name: "Ritu Raj Singh", affiliation: "NSUT Delhi", country: "India" },
  { name: "P. Kumar", affiliation: "Rajalakshmi Engineering College, Chennai", country: "India" },
  { name: "Varun Jain", affiliation: "ADGIPS, New Delhi", country: "India" },
  { name: "Mandeep Kaur", affiliation: "Bennett University, Greater Noida", country: "India" },
  { name: "Jagjit Singh Dhatterwal", affiliation: "SR University, Telangana", country: "India" },
  { name: "Ajay Kumar Sharma", affiliation: "Geetanjali Institute of Technical Studies, Udaipur (Affiliated to RTU, Kota)", country: "India" },
  { name: "Avdhesh Gupta", affiliation: "Ajay Kumar Garg Engineering College, Ghaziabad", country: "India" },
  { name: "Bhooesh Singh Bhati", affiliation: "Indian Institute of Information Technology, Sonepat", country: "India" },
  { name: "Pawan Singh", affiliation: "Central University of Rajasthan, Ajmer", country: "India" },
  { name: "Ritu Dewan", affiliation: "GCET, Greater Noida", country: "India" },
  { name: "Krishan Kumar", affiliation: "Chandigarh University, Mohali", country: "India" },
  { name: "Pinky Yadav", affiliation: "IILM University, Greater Noida", country: "India" },
  { name: "Pavandeep Kaur", affiliation: "Chandigarh University, Mohali", country: "India" },
  { name: "Akhilesh Sharma", affiliation: "North Eastern Regional Institute of Science and Technology, Nirjuli", country: "India" },
  { name: "Isha Sood", affiliation: "Ajeenkya DY Patil University, Pune", country: "India" },
  { name: "Moirangthem Marjit Singh", affiliation: "North Eastern Regional Institute of Science and Technology, Arunachal Pradesh", country: "India" },
  { name: "Lalit Kr Bansal", affiliation: "MMDU Mullana", country: "India" },
  { name: "Vivek Kumar Shrivastava", affiliation: "Maharishi Markendeshwar Deemed to be University, Mullana, Ambala, Haryana", country: "India" },
  { name: "Vikas", affiliation: "Ajay Kumar Garg Engineering College", country: "India" },
  { name: "Chandra Sekhar Koli", affiliation: "Aditya University, Surampalem, Andhra Pradesh", country: "India" },
  { name: "Raunak Raj", affiliation: "School of Computer Science and Engineering, Lovely Professional University", country: "India" },
  { name: "Rajashree Suryawanshi", affiliation: "Army Institute of Technology, Pune", country: "India" },
  { name: "Prashant Kumar", affiliation: "Galgotias University, Greater Noida", country: "India" },
  { name: "Varsha Thakur", affiliation: "GLA University, Mathura", country: "India" },
  { name: "Mylavarapu Seetharama Prasad", affiliation: "KLEF University", country: "India" },
  { name: "Bharat Bhushan Sagar", affiliation: "Harcourt Butler Technical University, Kanpur", country: "India" },

  { name: "Neha Sharma", affiliation: "IIMT College of Engineering, Greater Noida", country: "India" },
  { name: "Avinash Chandra Mani", affiliation: "Hindustan Aeronautics Limited, Kanpur", country: "India" },
  { name: "Dimple Tiwari", affiliation: "Vivekananda Institute of Professional Studies - Technical Campus, Delhi", country: "India" },
  { name: "Sanjay Kumar Sonkar", affiliation: "Shri Ramswaroop Memorial University, Lucknow – Deva Road, Barabanki (U.P.)", country: "India" },
  { name: "Sheenam Naaz", affiliation: "Sharda University, Greater Noida", country: "India" },
  { name: "Anuradha", affiliation: "Babasaheb Bhimrao Ambedkar University, Vidya Vihar, Raebareli Road, Lucknow", country: "India" },
  { name: "Sachin Balkrushna Jadhav", affiliation: "School of Computer and Systems Sciences, Jawaharlal Nehru University, New Delhi", country: "India" },
  { name: "Kavita Sharma", affiliation: "Galgotias College of Engineering and Technology, Greater Noida", country: "India" },
  { name: "Priya Solomon", affiliation: "GL Bajaj Institute of Management and Research", country: "India" },
  { name: "Terrance Frederick Fernandez", affiliation: "Saveetha School of Engineering, SIMATS", country: "India" },
  { name: "Kaushal Kishor", affiliation: "ABES Institute of Technology, Ghaziabad", country: "India" },
  { name: "Preeti Rani", affiliation: "Teerthanker Mahaveer University, Moradabad, Uttar Pradesh", country: "India" },
  { name: "Mainak Chakraborty", affiliation: "Adamas University, Kolkata", country: "India" },
  { name: "Sanjoy Das", affiliation: "Indira Gandhi National Tribal University Regional Campus, Manipur", country: "India" },
  { name: "Indrani Das", affiliation: "Assam University, Silchar, Assam", country: "India" },
  { name: "Dileep Kumar Yadav", affiliation: "Bennett University, Greater Noida, UP", country: "India" },
  { name: "Ritesh Kumar Singhal", affiliation: "Ajay Kumar Garg Institute of Management, Ghaziabad", country: "India" },
  { name: "Nitish Kumar", affiliation: "Lovely Professional University", country: "India" },
  { name: "Shyamsunder Chitta", affiliation: "Symbiosis Institute of Business Management, Hyderabad", country: "India" },
  { name: "Mahendra Kumar Jangir", affiliation: "Government Polytechnic College, Sikar, Rajasthan", country: "India" },
  { name: "Divya Prathamesh Surve", affiliation: "Vidyalankar Institute of Technology, Mumbai", country: "India" },
  { name: "Vishal Sahebrao Badgujar", affiliation: "A.P. Shah Institute of Technology, Thane", country: "India" },
  { name: "Kaku Riya Dharmendra", affiliation: "B.H. Gardi College of Engineering and Technology, Rajkot", country: "India" },
  { name: "Manmohan Meena", affiliation: "Government Polytechnic College, Sikar, Rajasthan", country: "India" },
  { name: "Umesh Kumar", affiliation: "JC Bose University of Science and Technology, YMCA, Faridabad, Haryana", country: "India" },
  { name: "Anil Kumar Sagar", affiliation: "Sharda University, Greater Noida", country: "India" },
  { name: "Nandini Sharma", affiliation: "Anand School of Engineering & Technology, Sharda University, Agra", country: "India" },
  { name: "Satvik Vats", affiliation: "Madan Mohan Malaviya University of Technology, Gorakhpur", country: "India" },
  { name: "Nitin Anand", affiliation: "National Institute of Technology, Manipur", country: "India" },
  { name: "Gourav Kumar Sharma", affiliation: "Amity University, Madhya Pradesh, Gwalior", country: "India" },
  { name: "Aditya Dev Mishra", affiliation: "Galgotias College of Engineering and Technology, Greater Noida", country: "India" },
  { name: "Om Prakash Yadav", affiliation: "Sandip Institute of Technology and Research Centre, Nashik, Maharashtra", country: "India" },
  { name: "Swimpy Pahuja", affiliation: "Reva University, Bengaluru", country: "India" },
  { name: "Srinibas Pattanaik", affiliation: "Chandigarh University, Mohali", country: "India" },
  { name: "Kamlesh Chandra Purohit", affiliation: "Graphic Era Deemed to be University, Dehradun", country: "India" },
  { name: "Manisha Yadav", affiliation: "Institute of Engineering and Technology, Dr. Rammanohar Lohia Avadh University, Ayodhya", country: "India" },
  { name: "Ranjit Rajajk", affiliation: "Dr. Harisingh Gour Central University, Sagar, MP", country: "India" },
  { name: "Mir Saqlain Sajad", affiliation: "Jamia Hamdard University, New Delhi", country: "India" },
  { name: "Nittu Goutham", affiliation: "Jawaharlal Nehru University", country: "India" },
  { name: "Hemlatha Kaur Saran", affiliation: "AiVONIC Technology Pvt Ltd, India", country: "India" },
  { name: "Sandeep Mathur", affiliation: "Amity University, Greater Noida", country: "India" },
  { name: "Shanthalakshmi Revathy", affiliation: "Velammal College of Engineering and Technology, Madurai", country: "India" },
  { name: "Anuj Kumar", affiliation: "Ajay Kumar Garg Engineering College, Ghaziabad", country: "India" },
  { name: "Shalu", affiliation: "Manav Rachna University, Faridabad", country: "India" },
  { name: "Mahesh Kumar Sharma", affiliation: "Amrapali University, Haldwani", country: "India" },
  { name: "Ajay Sikandar", affiliation: "Galgotias University, Greater Noida", country: "India" },
  { name: "Amit Kumar Goel", affiliation: "Integral Business Review, Integral University", country: "India" },
  { name: "Rahul Joshi", affiliation: "Symbiosis Institute of Technology, Pune", country: "India" },
  { name: "Aditi Mishra", affiliation: "SRMU, Varanasi", country: "India" },
  { name: "Vidya Sagar Thalapala", affiliation: "IIIT Kottayam, Pala", country: "India" },
  { name: "Karthick Panneerselvam", affiliation: "KPR Institute of Engineering and Technology, Coimbatore", country: "India" },
  { name: "Navneet Vishnoi", affiliation: "CCSIT, Teerthanker Mahaveer University, Moradabad", country: "India" },
  { name: "Shruthika Rajan", affiliation: "Amrita Vishwa Vidyapeetam", country: "India" },
  { name: "Indrajeet Kumar", affiliation: "Birla Global University, Bhubaneswar", country: "India" },


  { name: "Nitesh Singh Bhati", affiliation: "Gautam Buddha University, Greater Noida, UP", country: "India" },
{ name: "Nafees Akhter Farooqui", affiliation: "Koenru Lakshmaiah Education Foundation, Vaddeshwaram Campus, Guntur, AP", country: "India" },
{ name: "Jatin Arora", affiliation: "Chitkara University, Punjab", country: "India" },
{ name: "Jay Kumar Pandey", affiliation: "Shri Ramswaroop Memorial University, Lucknow Deva Road, Barabanki, U.P.", country: "India" },
{ name: "Pasupulati Baburao", affiliation: "Vel Tech Rangarajan Dr Sagunthala R&D Institute of Science and Technology, Avadi, Chennai", country: "India" },
{ name: "Lakhan Singh", affiliation: "JB Institute of Technology, Dehradun, Uttarakhand", country: "India" },
{ name: "Ankit Garg", affiliation: "Ajay Kumar Garg Institute of Management", country: "India" },
{ name: "Taniya", affiliation: "Chitkara University, Rajpura, Punjab", country: "India" },
{ name: "Sonam Mittal", affiliation: "Chitkara University, Rajpura, Punjab", country: "India" },
{ name: "Hemang Shrivastava", affiliation: "SAGE University, Indore", country: "India" },
{ name: "Ajeet Kumar Bhartee", affiliation: "Galgotias College of Engineering and Technology, Greater Noida", country: "India" },
{ name: "Ratneshwer", affiliation: "Jawaharlal Nehru University", country: "India" },
{ name: "Kumaresh Pal", affiliation: "Tata Steel Foundation, I.T.I.- Tamar", country: "India" },
{ name: "Nilotpal Pathak", affiliation: "Galgotias University, Greater Noida", country: "India" },
{ name: "Navneet Kumar", affiliation: "Jawaharlal Nehru University, New Delhi", country: "India" },
{ name: "Om Prakash", affiliation: "Jawaharlal Nehru University, New Delhi", country: "India" },
{ name: "Vikas Arya", affiliation: "Jawaharlal Nehru University, New Delhi", country: "India" },
{ name: "Meenakshi S.", affiliation: "R.M.K. Engineering College", country: "India" },
{ name: "Prof. Sandeep Singh Rawat", affiliation: "SOCIS, IGNOU", country: "India" },
{ name: "Ajai Kumar", affiliation: "Meerut Institute of Engineering and Technology, Meerut, Uttar Pradesh", country: "India" },
{ name: "Sushil Kumar Saroj", affiliation: "Madan Mohan Malaviya University of Technology, Gorakhpur", country: "India" },
{ name: "Baranidharan V", affiliation: "Bannari Amman Institute of Technology, Sathy", country: "India" },
{ name: "Sakshi Gupta", affiliation: "Jawaharlal Nehru University, New Delhi", country: "India" },
{ name: "Dharm Raj", affiliation: "Computer Science & Engineering, School of Computing Science & Engineering, Sharda University", country: "India" },
{ name: "Ajay Kumar Gupta", affiliation: "IIMT College of Engineering, Greater Noida", country: "India" },
{ name: "Neeraj Kumari", affiliation: "Moradabad Institute of Technology, Moradabad", country: "India" },
{ name: "Pradeep Kumar Shah", affiliation: "Teerthanker Mahaveer University, Moradabad", country: "India" },
{ name: "Vinod Patil", affiliation: "Bharati Vidyapeeth (Deemed to be University) College of Engineering, Pune", country: "India" },
{ name: "Amrit Kumar Agrawal", affiliation: "Sharda University, Greater Noida", country: "India" },
{ name: "Rajeev Shekhar Niranjan", affiliation: "Jawaharlal Nehru University", country: "India" },
{ name: "Satya Bhushan Verma", affiliation: "Shree Ramswaroop Memorial University, Barabanki", country: "India" },
{ name: "Anilkumar Suthar", affiliation: "Shankersinh Vaghela Bapu Institute of Technology, Gandhinagar", country: "India" },
{ name: "Manik Rakhra", affiliation: "Lovely Professional University", country: "India" },
{ name: "Hemant T. Ingale", affiliation: "Godavari College of Engineering, Jalgaon", country: "India" },
{ name: "Birendra Kumar Saraswat", affiliation: "GL Bajaj Institute of Technology and Management, Greater Noida", country: "India" },

{ name: "Aldrin Claytus Vaz", affiliation: "St Joseph Engineering College, Mangaluru", country: "India" },
{ name: "Aradhna Saini", affiliation: "GL Bajaj Institute of Technology and Management", country: "India" },
{ name: "P. Chinnasamy", affiliation: "Kalasalingam Academy of Research and Education", country: "India" },

{ name: "Shruti Kirti Rastogi", affiliation: "Babasaheb Bhimrao Ambedkar University, Lucknow", country: "India" },
{ name: "Ch. Venkateswara Rao", affiliation: "Vishnu Institute of Technology, Bhimavaram", country: "India" },
{ name: "Mahaveerakannan R", affiliation: "Saveetha School of Engineering, Chennai", country: "India" },
{ name: "Dandamudi Vijendra Kumar", affiliation: "Godavari Institute of Engineering & Technology (A), Rajahmundry", country: "India" },
{ name: "Khushabu Agrawal", affiliation: "K.C. College of Engineering & Management Studies & Research, Thane", country: "India" },

{ name: "Pawan Kumar Kushwaha", affiliation: "Galgotias College of Engineering and Technology, Greater Noida", country: "India" },
{ name: "Namit Gupta", affiliation: "Teerthanker Mahaveer University, Moradabad", country: "India" },
{ name: "Utukuru Sairam", affiliation: "CBIT, Hyderabad", country: "India" },

{ name: "Ajmeera Kiran", affiliation: "MLR Institute of Technology", country: "India" },
{ name: "Ankit Manderna", affiliation: "NIELIT, Aurangabad", country: "India" },

{ name: "Om Goel", affiliation: "Resagate Global, Ghaziabad", country: "India" },
{ name: "Pullela Harish Chowdary", affiliation: "Lovely Professional University, Phagwara", country: "India" },
{ name: "Divakar Yadav", affiliation: "SOCIS, IGNOU, New Delhi", country: "India" },
{ name: "Latha Banda", affiliation: "JEMTEC, Greater Noida", country: "India" },
{ name: "Anuj Mangal", affiliation: "GLA University, Mathura", country: "India" },
{ name: "K. Rajalakshmi", affiliation: "CMR Institute of Technology, Bangalore", country: "India" },


];



  return (

    <div className="container mt-5 text-center">

    <h3 className="card-title text-center text-danger my-5"><strong>CHIEF PATRON</strong></h3>
    
    <div class="row row-cols-1 row-cols-md-1 g-4">
        {Chief_Patron.map((title, index) => (
                <div class="col">
                    <div class="card h-100 shadow-lg p-3" style={{backgroundColor:"#FFF5EE"}}>
                    <div class="card-body">
                        <h5 class="card-title">{title.Name}</h5>
                        <p class="card-text">{title.Organization}</p>
                        <p class="card-text">{title.Country}</p>
                    </div>
                    </div>
                  </div>
      ))}
    </div>

    <h3 className="card-title text-center text-danger my-5"><strong>PATRONS</strong></h3>
    
    <div class="row row-cols-1 row-cols-md-3 g-4">
        {Patrons.map((title, index) => (
                <div class="col">
                    <div class="card h-100 shadow-lg p-3" style={{backgroundColor:"#FFF5EE"}}>
                    <div class="card-body">
                        <h5 class="card-title">{title.Name}</h5>
                        <p class="card-text">{title.Organization}</p>
                        <p class="card-text">{title.Country}</p>
                    </div>
                    </div>
                  </div>
      ))}
    </div>

    {/* <h3 className="card-title text-center text-danger my-5"><strong>CO-PATRONS</strong></h3>
    
    <div class="row row-cols-1 row-cols-md-2 g-4">
        {CoPatrons.map((title, index) => (
                <div class="col">
                    <div class="card h-100 shadow-lg p-3" style={{backgroundColor:"#FFF5EE"}}>
                    <div class="card-body">
                        <h5 class="card-title">{title.Name}</h5>
                        <p class="card-text">{title.Position}</p>
                        <p class="card-text">{title.Organization}</p>
                        <p class="card-text">{title.Country}</p>
                    </div>
                    </div>
                  </div>
      ))}
    </div> */}

    <h3 className="card-title text-center text-danger my-5"><strong>IEEE STREEING COMMITTEE</strong></h3>
    
    <div class="row row-cols-1 row-cols-md-2 g-4">
        {Ieee_streeing.map((title, index) => (
                <div class="col">
                    <div class="card h-100 shadow-lg p-3" style={{backgroundColor:"#FFF5EE"}}>
                    <div class="card-body">
                        <h5 class="card-title">{title.Name}</h5>
                        <p class="card-text">{title.Position}</p>
                        <p class="card-text">{title.Organization}</p>
                        <p class="card-text">{title.Country}</p>
                    </div>
                    </div>
                  </div>
      ))}
    </div>

    <h3 className="card-title text-center text-danger my-5"><strong>GENERAL CHAIRS</strong></h3>
    
    <div class="row row-cols-1 row-cols-md-3 g-4">
        {General_chair.map((title, index) => (
                <div class="col">
                    <div class="card h-100 shadow-lg p-3" style={{backgroundColor:"#FFF5EE"}}>
                    <div class="card-body">
                        <h5 class="card-title">{title.Name}</h5>
                        <p class="card-text">{title.Organization}</p>
                        <p class="card-text">{title.Country}</p>
                    </div>
                    </div>
                  </div>
    ))}
  </div>

    <h3 className="card-title text-center text-danger my-5"><strong>CONFERENCE CHAIRS</strong></h3>
    
    <div class="row row-cols-1 row-cols-md-3 g-4">
        {conference_chair.map((title, index) => (
                <div class="col">
                    <div class="card h-100 shadow-lg p-3" style={{backgroundColor:"#FFF5EE"}}>
                    <div class="card-body">
                        <h5 class="card-title">{title.Name}</h5>
                        <p class="card-text">{title.Organization}</p>
                        <p class="card-text">{title.Country}</p>
                    </div>
                    </div>
                </div>
      ))}
    </div>

      <h3 className="card-title text-center text-danger my-5"><strong>CONFERENCE CO-CHAIR</strong></h3>
      <div class="row row-cols-1 row-cols-md-3 g-4">
        {Conveners.map((title, index) => (
                <div class="col">
                    <div class="card h-100 shadow-lg p-3" style={{backgroundColor:"#FFF5EE"}}>
                    <div class="card-body">
                        <h5 class="card-title">{title.Name}</h5>
                        <p class="card-text">{title.Organization}</p>
                        <p class="card-text">{title.Country}</p>
                    </div>
                    </div>
                </div>
        ))}
      </div>

      <h3 className="card-title text-center text-danger my-5"><strong>TECHNICAL PROGRAM CHAIRS</strong></h3>
      <div class="row row-cols-1 row-cols-md-3 g-4">
        {Technical_program_chairs.map((title, index) => (
                <div class="col">
                    <div class="card h-100 shadow-lg p-3" style={{backgroundColor:"#FFF5EE"}}>
                    <div class="card-body">
                        <h5 class="card-title">{title.Name}</h5>
                        <p class="card-text">{title.Organization}</p>
                        <p class="card-text">{title.Country}</p>
                    </div>
                    </div>
                </div>
        ))}
      </div>
      
      <div className="d-flex justify-content-center align-items-center my-5">
          <Link to="/tracks" type="button" class="btn btn-outline-danger"> <h3>Track Chairs</h3> </Link>
      </div>

      {/* <div class="row row-cols-1 row-cols-md-1 g-4">
        {Technical_program_chairs.map((title, index) => (
          <div class="card shadow-lg">
              <div class="card-header">
                <h5 className="card-title text-center text-danger"><strong>{title.Track}</strong></h5>
              </div>
              <div class="card-body">
                <div class={title.Chairs.length==3?"row row-cols-1 row-cols-md-3 g-4":"row row-cols-1 row-cols-md-2 g-4"} >
                {title.Chairs.map((e,index1)=>(
                  
                  <div class="col">
                  
                    <div class="card h-100 shadow p-3" style={{backgroundColor:"#FFF5EE"}}>
                    <div class="card-body">
                        <h5 class="card-title">{e.Name}</h5>
                        <p class="card-text">{e.Organization}</p>
                        <p class="card-text">{e.Country}</p>
                    </div>
                    </div>
                </div>
                
                ))}
                </div>
              </div>
            
                
              </div>
        ))}
      </div> */}

      <h3 className="card-title text-center text-danger my-5"><strong>FUND RAISING COMMITTEE</strong></h3>
      <div class="row row-cols-1 row-cols-md-4 g-4">
        {Fund_raising_committee.map((title, index) => (
                <div class="col">
                    <div class="card h-100 shadow-lg p-3" style={{backgroundColor:"#FFF5EE"}}>
                    <div class="card-body">
                        <h5 class="card-title">{title.Name}</h5>
                        <p class="card-text">{title.Organization}</p>
                        <p class="card-text">{title.Country}</p>
                    </div>
                    </div>
                </div>
        ))}
      </div>

      <h3 className="card-title text-center text-danger my-5"><strong>REGISTRATION COMMITTEE</strong></h3>
      <div class="row row-cols-1 row-cols-md-4 g-4">
        {Registration_committee.map((title, index) => (
                <div class="col">
                    <div class="card h-100 shadow-lg p-3" style={{backgroundColor:"#FFF5EE"}}>
                    <div class="card-body">
                        <h5 class="card-title">{title.Name}</h5>
                        <p class="card-text">{title.Organization}</p>
                        <p class="card-text">{title.Country}</p>
                    </div>
                    </div>
                </div>
        ))}
      </div>

      <h3 className="card-title text-center text-danger my-5"><strong>FINANCE COMMITTEE</strong></h3>
      <div class="row row-cols-1 row-cols-md-4 g-4">
        {Finance_committee.map((title, index) => (
                <div class="col">
                    <div class="card h-100 shadow-lg p-3" style={{backgroundColor:"#FFF5EE"}}>
                    <div class="card-body">
                        <h5 class="card-title">{title.Name}</h5>
                        <p class="card-text">{title.Organization}</p>
                        <p class="card-text">{title.Country}</p>
                    </div>
                    </div>
                </div>
        ))}
      </div>

      
      <h3 className="card-title text-center text-danger my-5"><strong>PUBLICATION COMMITTEE</strong></h3>
      <div class="row row-cols-1 row-cols-md-4 g-4">
        {Publication_committee.map((title, index) => (
                <div class="col">
                    <div class="card h-100 shadow-lg p-3" style={{backgroundColor:"#FFF5EE"}}>
                    <div class="card-body">
                        <h5 class="card-title">{title.Name}</h5>
                        <p class="card-text">{title.Organization}</p>
                        <p class="card-text">{title.Country}</p>
                    </div>
                    </div>
                </div>
        ))}
      </div>

      <h3 className="card-title text-center text-danger my-5"><strong>POSTER AND DEMONSTRATION COMMITTEE</strong></h3>
      <div class="row row-cols-1 row-cols-md-4 g-4">
        {Poster_and_demonstration_committee.map((title, index) => (
                <div class="col">
                    <div class="card h-100 shadow-lg p-3" style={{backgroundColor:"#FFF5EE"}}>
                    <div class="card-body">
                        <h5 class="card-title">{title.Name}</h5>
                        <p class="card-text">{title.Organization}</p>
                        <p class="card-text">{title.Country}</p>
                    </div>
                    </div>
                </div>
        ))}
      </div>

      

      <h3 className="card-title text-center text-danger my-5"><strong>WEB COMMITTEE</strong></h3>
      <div class="row row-cols-1 row-cols-md-4 g-4">
        {Web_committee.map((title, index) => (
                <div class="col">
                    <div class="card h-100 shadow-lg p-3" style={{backgroundColor:"#FFF5EE"}}>
                    <div class="card-body">
                        <h5 class="card-title">{title.Name}</h5>
                        <p class="card-text">{title.Organization}</p>
                        <p class="card-text">{title.Country}</p>
                    </div>
                    </div>
                </div>
        ))}
      </div>

      <h3 className="card-title text-center text-danger my-5"><strong>PUBLICITY AND PUBLIC RELATIONS COMMITTEE</strong></h3>
      <div class="row row-cols-1 row-cols-md-4 g-4">
        {Publicity_and_public_relations_committee.map((title, index) => (
                <div class="col">
                    <div class="card h-100 shadow-lg p-3" style={{backgroundColor:"#FFF5EE"}}>
                    <div class="card-body">
                        <h5 class="card-title">{title.Name}</h5>
                        <p class="card-text">{title.Organization}</p>
                        <p class="card-text">{title.Country}</p>
                    </div>
                    </div>
                </div>
        ))}
      </div>

      
      <h3 className="card-title text-center text-danger my-5"><strong>SPECIAL SESSION COMMITTEE</strong></h3>
      <div class="row row-cols-1 row-cols-md-5 g-4">
        {Special_session_committee.map((title, index) => (
                <div class="col">
                    <div class="card h-100 shadow-lg p-3" style={{backgroundColor:"#FFF5EE"}}>
                    <div class="card-body">
                        <h5 class="card-title">{title.Name}</h5>
                        <p class="card-text">{title.Organization}</p>
                        <p class="card-text">{title.Country}</p>
                    </div>
                    </div>
                </div>
        ))}
      </div>

      <h3 className="card-title text-center text-danger my-5"><strong>EVENT MANAGEMENT COMMITTEE</strong></h3>
      <div class="row row-cols-1 row-cols-md-4 g-4">
        {Event_management_committee.map((title, index) => (
                <div class="col">
                    <div class="card h-100 shadow-lg p-3" style={{backgroundColor:"#FFF5EE"}}>
                    <div class="card-body">
                        <h5 class="card-title">{title.Name}</h5>
                        <p class="card-text">{title.Organization}</p>
                        <p class="card-text">{title.Country}</p>
                    </div>
                    </div>
                </div>
        ))}
      </div>

      
      <h3 className="card-title text-center text-danger my-5"><strong>ADVISORY COMMITTEE</strong></h3>
      <div class="row row-cols-1 row-cols-md-4 g-4">
        {Advisory_committee.map((title, index) => (
                <div class="col">
                    <div class="card h-100 shadow-lg p-3" style={{backgroundColor:"#FFF5EE"}}>
                    <div class="card-body">
                        <h5 class="card-title">{title.Name}</h5>
                        <p class="card-text">{title.Organization}</p>
                        <p class="card-text">{title.Country}</p>
                    </div>
                    </div>
                </div>
        ))}
      </div>
      
      <h1 className="border-bottom my-5 text-danger">TECHNICAL PROGRAM COMMITTEE</h1>
      <h3 className="card-title text-center text-danger my-5"><strong>International</strong></h3>
      <div class="row row-cols-1 row-cols-md-4 g-4">
        {InternationalTPC.map((title, index) => (
                <div class="col">
                    <div class="card h-100 shadow-lg p-3" style={{backgroundColor:"#FFF5EE"}}>
                    <div class="card-body">
                        <h5 class="card-title">{title.Name}</h5>
                        <p class="card-text">{title.Organization}</p>
                        <p class="card-text">{title.Country}</p>
                    </div>
                    </div>
                </div>
        ))}
      </div>


      <h3 className="card-title text-center text-danger my-5"><strong>National</strong></h3>
      <div class="row row-cols-1 row-cols-md-4 g-4">
        {nationalTPC.map((title, index) => (
                <div class="col">
                    <div class="card h-100 shadow-lg p-3" style={{backgroundColor:"#FFF5EE"}}>
                    <div class="card-body">
                        <h5 class="card-title">{title.name}</h5>
                        <p class="card-text">{title.affiliation}</p>
                        <p class="card-text">{title.country}</p>
                    </div>
                    </div>
                </div>
        ))}
      </div>
      
      {/* <div className="my-5">
        <a href={reviewers} type="button" class="btn btn-outline-danger" download="Reviewer_list"><h3>Reviewer List</h3> </a>
      </div> */}
      
      {/* Inline keyframes */}
      <style>
        {`
          @keyframes scroll-left {
            0% { transform: translateX(100%); }
            100% { transform: translateX(-100%); }
          }
        `}
      </style>
    </div>
  );
};

export default Committee;
